import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

const getTotalActiveUser = (fromDate, toDate, userGroupId) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ADOPTION_REPORT.GET_TOTAL_ACTIVE_USERS(
      fromDate,
      toDate,
      userGroupId
    ),
    cancelToken
  );
};

export default getTotalActiveUser;
